// extracted by mini-css-extract-plugin
export default {"grayBody":"Comment-grayBody_hQY","reply":"Comment-reply_BNx"};